import { useExplorePageGetProductTiles } from "@faire/retailer/views/explore-page/__internal__/useExplorePageGetProductTiles";
import { useExplorePageProductsQuery } from "@faire/retailer/views/explore-page/__internal__/useExplorePageProductsQuery";

export const useExplorePageShowCTAAndInlineFilter = () => {
  const { totalPrimaryResults } = useExplorePageProductsQuery();
  const productTiles = useExplorePageGetProductTiles();
  return totalPrimaryResults > productTiles.length;
};
